import { http, HttpResponse } from 'msw';
import { userFactory } from '@trukt/factories/userFactory';
import { mockTruktTmsApiUrl } from '../mocks';
import { UserSearchResponse } from '../services/UserService/UserService.types';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/users'), () => {
    return HttpResponse.json<UserSearchResponse>({
      page: 1,
      rows: 3,
      next: false,
      results: [
        {
          guid: 'dc77c330-966f-4e05-ad39-9f2f46d38dbd',
          name: 'Alex Marinov',
          email: 'Alex.Marinov@acertusdelivers.com',
          mobileNumber: null,
          canLogin: true,
          role: {
            guid: '4',
            name: 'user',
          },
        },
        {
          guid: 'ca2a12bf-b561-4ad2-b029-e40fc76ccbf8',
          name: 'Aman Lal',
          email: 'Aman.Lal@acertusdelivers.com',
          mobileNumber: null,
          canLogin: true,
          role: {
            guid: '4',
            name: 'user',
          },
        },
        {
          guid: '53de0ee2-3b07-45a0-86ed-cabc8be99be2',
          name: 'Andrey Kurudimov',
          email: 'Andrey.Kurudimov@acertusdelivers.com',
          mobileNumber: null,
          canLogin: true,
          role: {
            guid: '4',
            name: 'user',
          },
        },
      ],
    });
  }),
  http.get(mockTruktTmsApiUrl('/users/me'), () => {
    return HttpResponse.json({
      ...userFactory.build(),
      role: { guid: '1', name: 'Admin' },
    });
  }),
];
